import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/es";
import { getAuditLogs } from "../../services/audit/audit.service";
import { AuditLogEntry } from "../../services/audit/audit.types";

dayjs.extend(relativeTime);

const { Text } = Typography;

export interface LastModifiedProps {
  /** Backend route prefix for this entity: "resources", "courses", etc. */
  entityType: string;
  entityId: number;
}

/**
 * Discreet "Última modificación: <relative date> por <actor>" line for edit
 * forms, sourced from the newest audit entry of the entity (a single
 * `limit: 1` request on mount). Entities without audit history (pre-feature
 * data) and service failures render nothing — no noisy placeholder.
 */
const LastModified: React.FC<LastModifiedProps> = ({
  entityType,
  entityId,
}) => {
  const [entry, setEntry] = useState<AuditLogEntry | null>(null);

  useEffect(() => {
    let cancelled = false;
    getAuditLogs({
      entity_type: entityType,
      entity_id: entityId,
      page: 1,
      limit: 1,
    })
      .then((response) => {
        if (!cancelled) setEntry(response.data[0] ?? null);
      })
      .catch(() => {
        // Silent degradation: the form header simply omits the line.
        if (!cancelled) setEntry(null);
      });
    return () => {
      cancelled = true;
    };
  }, [entityType, entityId]);

  if (!entry) return null;

  return (
    <div style={{ marginBottom: 12 }}>
      <Link to={`/actividad?entity_type=${entityType}&entity_id=${entityId}`}>
        <Text
          type="secondary"
          style={{ fontSize: 12 }}
          title={dayjs(entry.created_at).format("DD/MM/YYYY HH:mm")}
        >
          Última modificación {dayjs(entry.created_at).locale("es").fromNow()}{" "}
          por {entry.actor_name}
        </Text>
      </Link>
    </div>
  );
};

export default LastModified;
